// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SignatureEditCreate_formContainer__27mgM","form":"SignatureEditCreate_form__3NRs7","paper":"SignatureEditCreate_paper__20aVf"};